import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";
import WorkItemType from "../work-item-type";
import { WorkItemTypeTabButtons } from "../../constants/work-item-type-tab-buttons";
import * as ko from "knockout";

/**
 * ViewModel for WorkItemTypeTab
 */
class WorkItemTypeTab extends GenericListSearchTab {

    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Parent = parent;

        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    // #endregion Constructor

    // #region Properties

    /**
     *  Bao object to access session objects
     */
    Bao = Bao;

    /**
     * Controller Url 
     */
    ControllerUrl = "WorkItemTypeTab";
     
    /**
     * Parent of Tab
     */
    Parent: WorkItemType;

    // #endregion Properties

    // #region Public Methods

    /**
     * Returns custom filters
     * @returns Custom filters
     */
    CustomFilter = (): Models.HashObject[] => {
        let customFilterHashObject: Models.HashObject[] = [];
        return customFilterHashObject;
    }

    /**
     * Checks if the view model has been set correctly
     * @returns JqueryPromise<boolean>
     */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        return def.promise();
    }

    /**
     * Returns name of search type
     * @returns Name of search type
     */
    SearchType() {
        return "WorkItemTab";
    }

    /**
    * Override init method to not override title set by parent Module
    * @returns JQuery Promise
    */
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);

        return Bao.post(this.UrlInit(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            customFilter: this.CustomFilter(),
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result: Factories.GenericListResponse.InitResponse) => {
            this.Models(result.Models);
            this.TotalRows(result.TotalRows);
            this.PermissionAdd = result.Definition.PermissionAdd;
            this.PermissionEdit = result.Definition.PermissionEdit;
            this.PermissionRemove = result.Definition.PermissionRemove;
            this.BindingToolbar.formName = result.Definition.FormName;
            this.BindingToolbar.applicationId = result.Definition.ApplicationId;
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }


    /**
     * Toggles the state of toolbar buttons.
     */
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            const key = button.ActionKey();
            if (key === WorkItemTypeTabButtons.WORK_ITEM_TYPE_TAB_MOVE_UP || key === WorkItemTypeTabButtons.WORK_ITEM_TYPE_TAB_MOVE_DOWN) {
                button.Enabled(this.Selection() != null && this.Selection().length > 0);
            }
        });
    }

    /**
     * Handles custom toolbar button click events.
     * @param {any} action - The action to perform.
     */
    CustomToolbarClick = (action) => {
        const key = action.ActionKey();
        if (key === WorkItemTypeTabButtons.WORK_ITEM_TYPE_TAB_MOVE_UP || key === WorkItemTypeTabButtons.WORK_ITEM_TYPE_TAB_MOVE_DOWN) {
            this.moveWorkItemTypeTab(key.replace("WorkItemTypeTab", ""));
        }
    };
    // #endregion Public Methods

    //#region Protected Methods

    /**
     * Moves the WorkItemTypeTab up or down.
     * @protected
     * @param {string} action - The action to perform (MoveUp/MoveDown).
     */
    protected moveWorkItemTypeTab = (action: string) => {
        this.TabPage.IsLoading(true);
        const guidList = this.Selection().map(item => ko.unwrap(item.WorkItemTypeTabId));

        Bao.post(`${this.ControllerUrl}/WorkItemTypeTab${action}`, JSON.stringify({
            sessionTabId: this.SessionTabId,
            id: guidList
        }))
            .then(() => this.Get())
            .then(() => this.TabPage.DirtyFlag(true));
    }

    //#endregion
}
export default WorkItemTypeTab;